/** Canonical route table. Never hard-code a path anywhere else. */
export const ROUTES = Object.freeze({
  home: "/",
  sourceToPay: "/source-to-pay",
  solutions: "/solutions",
  platform: "/platform",
  about: "/about",
  contact: "/contact",
  notFound: "*",
});

/** `hash(ROUTES.platform, "ai-engine")` -> "/platform#ai-engine" */
export const hash = (route, fragment) => `${route}#${fragment}`;

/** "Purchase Order" -> "purchase-order" */
export const slugify = (value) =>
  String(value)
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

export default ROUTES;
